import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, create, update, getList, setPaginaAtual } from './planoActions';

import List from './planoList';
import Form from './planoForm';
import ListPlanoIntervalo from './planoIntervalo';
import PermissaoUsuario from '../auth/permissao';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SelectConfControlador from '../common/selectdb/selectConfControlador';

class Plano extends Component {
  constructor() {
    super();
    this.state = {
      isRealTime: false,
      alteraPagina: true,
    };
  }

  componentWillMount() {
    this.changeControlador = this.changeControlador.bind(this);
    this.props.init();
  }

  changeControlador() {
    this.props.init();

    if (this.state.alteraPagina) {
      this.props.setPaginaAtual(0);
    }
  }

  alteraPagina = bAltera => {
    this.setState({ alteraPagina: bAltera });
  };

  render() {
    return (
      <div className="cad-plano-premium">
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadPlano" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>

              <TabHeader label="Configurar" icon="cog" target="tabIntervalo" />
              <div className="cad-plano-filter-tabs">
                <div className="form-group cad-plano-filter-group cad-plano-filter-group-fisico">
                  <label className="cad-plano-filter-label">Grupo Físico:</label>
                  <SelectConfGrupoFisico
                    onChange={this.changeControlador}
                    emptyText="Todos"
                    customStyle={{
                      width: '100%',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group cad-plano-filter-group cad-plano-filter-group-controlador">
                  <SelectConfControlador
                    anel={false}
                    onChange={this.changeControlador}
                    emptyText="Todos"
                    customStyle={{
                      width: '300px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List alteraPagina={this.alteraPagina} permiteAlterarPagina={this.alteraPagina} />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" premiumLayout={true} />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form
                  onSubmit={this.props.update}
                  readOnly={true}
                  submitClass="primary"
                  submitLabel="Salvar"
                  premiumLayout={true}
                />
              </TabContent>
              <TabContent id="tabIntervalo">
                <ListPlanoIntervalo />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update, getList, setPaginaAtual }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(Plano);
